import './Loading.css';

export default function Loading() {
  return <div className="-layout-h -justify-center -align-center">
    <div className="lds-heart">
      <div></div>
    </div>
  </div>;
}